export function sortByPriority(a, b) {
  if (a.priority === b.priority) return 0;

  if (a.priority === 0) return 1;

  if (b.priority === 0) return -1;

  return a.priority - b.priority;
}
